import { convertDate } from '../helpers/convertDate';

export interface PersonalData {
    gender?: number | string;
    firstName?: string;
    lastName?: string;
    dateOfBirth?: string | null;
    countryOfResidence?: string | null;
    countryOfNationality?: string | null;
    street?: string;
    PLZ?: string;
    ORT?: string;
    maritalStatus?: string;
    language?: string;
    showSecondaryAdress: boolean;
    land: string | null;
    secondaryStreet: string | null;
    secondaryPLZ: string | null;
    secondaryORT: string | null;
    primaryPhoneNumber?: string;
    primaryEmail?: string;
    countryOfBirth?: string;
    isUsPerson?: boolean;
    hasUsResidence?: boolean;
    classedUsPerson?: (string | boolean | undefined)[];
    usCitizen?: boolean;
    hideDatePickerValue: boolean;

    // Mailing Address Fields
    mailRecipientGender?: number | string;
    mailRecipientLanguage?: number | string;
    mailRecipientAddressCountry?: number | string;
    mailRecipientAddressLine1?: string;
    mailRecipientAddressLine2?: string;
    mailRecipientAddressLine3?: string;
    mailRecipientAddressLine4?: string;
    mailRecipientAddressLine5?: string;
    mailRecipientFirstName?: string;
    mailRecipientLastName?: string;
    mailRecipientSalutation?: string;
}

export const getModel = (outputData: any): PersonalData => ({
    gender: outputData?.details?.personalInformation?.gender,
    firstName: outputData?.details?.personalInformation?.firstName,
    lastName: outputData?.details?.personalInformation?.lastName,
    dateOfBirth: outputData?.details?.personalInformation?.dateOfBirth
        ? convertDate(outputData?.details?.personalInformation?.dateOfBirth)
        : null,
    countryOfResidence: String(outputData?.details?.personalInformation?.primaryAddressCountry || ''),
    countryOfNationality: outputData.details?.personalInformation?.identification
        ? String(outputData.details?.personalInformation?.identification[0]?.countryOfNationality)
        : null,
    street: outputData?.details?.personalInformation?.primaryAddressStreet,
    PLZ: outputData?.details?.personalInformation?.primaryAddressPostalCode,
    ORT: outputData?.details?.personalInformation?.primaryAddressCity,
    maritalStatus: String(outputData?.details?.personalInformation?.maritalStatus || ''),
    language: String(outputData?.details?.personalInformation?.language || ''),
    showSecondaryAdress: !!outputData?.details?.communicationMethods?.mailRecipient?.mailRecipientAddressCountry,
    land: outputData?.details?.communicationMethods?.mailRecipient?.mailRecipientAddressCountry
        ? String(outputData?.details?.communicationMethods?.mailRecipient?.mailRecipientAddressCountry)
        : null,
    secondaryStreet: outputData?.details?.communicationMethods?.mailRecipient?.mailRecipientAddressLine3 || null,
    secondaryPLZ: outputData?.details?.communicationMethods?.mailRecipient?.mailRecipientAddressLine4 || null,
    secondaryORT: outputData?.details?.communicationMethods?.mailRecipient?.mailRecipientAddressLine5 || null,
    primaryPhoneNumber: outputData?.details?.personalInformation?.primaryPhoneNumber,
    primaryEmail: outputData?.details?.personalInformation?.primaryEmail,
    countryOfBirth: String(outputData?.details?.personalInformation?.countryOfBirth || ''),
    isUsPerson: outputData?.details?.taxSituation?.isUsPerson,
    hasUsResidence: outputData?.details?.taxSituation?.hasUsResidence,
    classedUsPerson: [outputData?.details?.taxSituation?.classedUsPerson],
    usCitizen: outputData?.details?.taxSituation?.isUsCitizenOrSubjectToUsTax,
    hideDatePickerValue: false,

    mailRecipientGender: outputData.details?.communicationMethods?.mailRecipient?.mailRecipientGender,
    mailRecipientLanguage: outputData.details?.communicationMethods?.mailRecipient?.mailRecipientLanguage,
    mailRecipientAddressCountry: outputData.details?.communicationMethods?.mailRecipient?.mailRecipientAddressCountry,
    mailRecipientAddressLine1: outputData.details?.communicationMethods?.mailRecipient?.mailRecipientAddressLine1,
    mailRecipientAddressLine2: outputData.details?.communicationMethods?.mailRecipient?.mailRecipientAddressLine2,
    mailRecipientAddressLine3: outputData.details?.communicationMethods?.mailRecipient?.mailRecipientAddressLine3,
    mailRecipientAddressLine4: outputData.details?.communicationMethods?.mailRecipient?.mailRecipientAddressLine4,
    mailRecipientAddressLine5: outputData.details?.communicationMethods?.mailRecipient?.mailRecipientAddressLine5,
    mailRecipientFirstName: outputData.details?.communicationMethods?.mailRecipient?.mailRecipientFirstName,
    mailRecipientLastName: outputData.details?.communicationMethods?.mailRecipient?.mailRecipientLastName,
    mailRecipientSalutation: outputData.details?.communicationMethods?.mailRecipient?.mailRecipientSalutation,
});
